import { AfterViewInit, Component, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { finalize } from 'rxjs';
import { MspDashboardSummary } from '../../interfaces/msp-dashboard-kpi';
import { ManagedServicesSharedDataService } from '../../../services/managed-services-shared-data.service';
import { environment } from 'src/environments/environment';
import { MSPDashboardV2Component } from '../msp-dashboard-v2.component';

@Component({
  selector: 'app-dashboard-summaries',
  templateUrl: './dashboard-summaries.component.html',
  styleUrls: ['./dashboard-summaries.component.scss'],
  standalone: false,
})
export class DashboardSummariesComponent extends MSPDashboardV2Component implements OnChanges, AfterViewInit {
  @Input() dashboard: string;
  @Input() boards: string[] = [];

  @ViewChild(MatSort) sort: MatSort;

  isFetching = false;
  errorFetching = false;
  totalCount = 0;
  displayedColumns = ['summary', 'count'];
  dataSource = new MatTableDataSource<{ summary: string; count: number }>([]);

  constructor(
    private http: HttpClient,
    private router: Router,
    private managedServicesSharedDataService: ManagedServicesSharedDataService,
  ) {
    super();
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['dashboard']?.currentValue) {
      this.fetch();
    }
  }

  filterBySummary(summary: string) {
    this.managedServicesSharedDataService.resetFilters();
    this.managedServicesSharedDataService.filters.summary = summary;
    this.navigate('open');
  }

  retry() {
    this.fetch();
  }

  private fetch() {
    this.isFetching = true;
    this.isFetchingKpis.emit(true);
    this.errorFetching = false;

    this.http
      .get<MspDashboardSummary[]>(`${environment.restUrl}/v1/msp/dashboards/${this.dashboard}/summaries`)
      .pipe(
        finalize(() => {
          this.isFetching = false;
          this.isFetchingKpis.emit(false);
        }),
      )
      .subscribe({
        next: (summaries) => {
          this.dataSource.data = summaries;
          this.totalCount = summaries.reduce((sum, s) => sum + s.count, 0);
        },
        error: () => (this.errorFetching = true),
      });
  }

  private navigate(statusType: 'open' | 'closed' | null) {
    this.managedServicesSharedDataService.filters.boardNames = this.boards;
    this.managedServicesSharedDataService.filters.relationship = 'parent';
    this.managedServicesSharedDataService.filters.statusesGroup = statusType ? [statusType] : [];
    this.router.navigateByUrl(`/secured/managed-services/tickets?refresh=${Date.now()}`);
  }
}
